export default {
    USERCENTER_PREFIX: process.env.REACT_APP_USERCENTER_PREFIX,
    HEALTHCLASS_URL_PREFIX: process.env.REACT_APP_HEALTHCLASS_URL_PREFIX,
    UCENTER_URL: process.env.REACT_APP_UCENTER_URL,

    API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
    GATEWAY_API_PREFIX: process.env.REACT_APP_GATEWAY_API_PREFIX,
    USER_API_PREFIX: process.env.REACT_APP_USER_API_PREFIX,
    USER_API_URL: process.env.REACT_APP_USER_API_URL,
    API_HEALTHCLASS_URL: process.env.REACT_APP_HEALTHCLASS_API_PREFIX,
    VODMEDIA_API_PREFIX: process.env.REACT_APP_VODMEDIA_API_PREFIX,

    FILE_URL_PREFIX: process.env.REACT_APP_FILE_URL_PREFIX,
    OSS_URL_PREFIX: process.env.REACT_APP_OSS_URL_PREFIX,
};
